import React, { useEffect, useState } from "react";
import { getWorkTypeList } from "../../../utils/Helpers/GetWorkTypes"
import { getSpecialitiesList } from "../../../utils/Helpers/GetSpecialities";

import Select from "react-select";

export default function SpecialitiesFilters({
  onSelectSpecilities,
  reset,
  borderTrue,
  ismultiple,
  preSelectedValues,
  isdisabled,
  no_used_cached
}) {
  const [selectedWorkType, setSelectedWorkType] = useState(
    ismultiple ? [] : ""
  );

  const [list, setList] = useState([]);

  useEffect(() => {
    console.log("preSelectedValues sadf asdf", preSelectedValues);
    if (
      preSelectedValues &&
      Array.isArray(preSelectedValues) &&
      list.length > 0 
    ) {

      const preSelectedOptions = list.filter((option) =>
        preSelectedValues.includes(option.value)
      );

      console.log("preSelectedOptions", preSelectedOptions);

      setSelectedWorkType(
        ismultiple ? preSelectedOptions : preSelectedOptions[0] || ""
      );
    }
  }, [list, preSelectedValues, ismultiple]);

  useEffect(() => {
    if (reset) {
      setSelectedWorkType(ismultiple ? [] : "");
    }
  }, [reset]);

  useEffect(() => {
    const loadData = async () => {
      setList(await getSpecialitiesList(no_used_cached));
    };

    loadData();
  }, []);

  const handleChange = (workType) => {
    setSelectedWorkType(workType);
    if (ismultiple) {
      onSelectSpecilities(workType.map((option) => option.value));
    } else {
      onSelectSpecilities(workType?.value || "");
    }
  };

  return (
    <Select
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          borderColor: "#9FAFCA",
          borderWidth: "3px",
          borderTop: !borderTrue && "none",
          borderLeft: !borderTrue && "none",
          borderRight: !borderTrue && "none",
          boxShadow: borderTrue && "none",
          "&:hover": {
            borderColor: "#2684FF",
          },
        }),
        dropdownIndicator: (provided, state) => ({
          ...provided,
          color: "#a71e1e",
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#6c757d",
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#9FAFCA" : "white",
          color: state.isSelected ? "white" : "black",
          "&:hover": {
            backgroundColor: "#9FAFCA",
            color: "white",
          },
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          borderRadius: 0,
        }),
      }}
      options={list}
      value={selectedWorkType}
      onChange={handleChange}
      placeholder="Select Specialities"
      isMulti={ismultiple}
      isSearchable
      isDisabled={isdisabled}
  
    />
  );
}
